import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { DateComponent } from '@core/time-ui';
import { DividerComponent, HeadingComponent, BoxComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-interview-base-box',
  templateUrl: 'interview-base-box.component.html',
  styleUrls: ['./interview-base-box.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BoxComponent, HeadingComponent, DateComponent, DividerComponent, TranslatePipe],
})
export class InterviewBaseBoxComponent {
  public readonly padding = input<boolean>(true);
  public readonly invalid = input<boolean>(false);
  public readonly errorMessage = input<string | null>(undefined!);
  @Input() public question: {
    questionHint?: string;
    questionRequired?: boolean;
    questionTitle: string;
    time?: number | string;
    summary?: boolean;
  };
}
